import React from 'react';
import { Container } from 'reactstrap';
import { get } from 'lodash-es';

import DiyTitleBar from '../DiyTitleBar';
import DiyStepBar from '../DiyStepBar';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';

/**
 * These steps are very similar so just point to existing
 * components and use isBin permutations
 */

// This is step 4 in live/timed, step 3 in BIN
import Step4 from '../Step4/Step4';
// This is step 5 in live/timed, step 4 in BIN
import Step5 from '../Step5/Step5';
// This is step 6 in live/timed, step 5 in BIN
import Step6 from '../Step6/Step6';

import Step7 from '../Step7/Step7';

const getCurrentStepComponent = step => {
  switch (step) {
    case 1:
      return <Step1 />;
    case 2:
      return <Step2 />;
    // Use identical code from live/timed for steps 3-5
    case 3:
      return <Step4 />;
    case 4:
      return <Step5 />;
    case 5:
      return <Step6 />;
    case 6:
      return <Step6 />;
    case 7:
      return <Step7 />;
    default:
      return <Step1 />;
  }
};

const BinContainer = props => {
  // /session/groupid/catalogid/step
  let step = parseInt(get(props, 'match.params.step', 1), 10);

  document.title = 'InvaluableAuctions - DIY Session';

  return (
    <Container className="py-4">
      <DiyStepBar step={step} bin={true} />
      <DiyTitleBar step={step} bin={true} />

      {getCurrentStepComponent(step)}
    </Container>
  );
};

export default BinContainer;
